[
  {
    "code": "SINGLE",
    "label": {
      "en": "Single",
      "es": "Soltero/a"
    },
    "order": 1,
    "is_active": true
  },
  {
    "code": "MARRIED",
    "label": {
      "en": "Married",
      "es": "Casado/a"
    },
    "order": 2,
    "is_active": true
  },
  {
    "code": "DOMESTIC_PARTNERSHIP",
    "label": {
      "en": "Domestic Partnership",
      "es": "Pareja de hecho"
    },
    "order": 3,
    "is_active": true
  },
  {
    "code": "DIVORCED",
    "label": {
      "en": "Divorced",
      "es": "Divorciado/a"
    },
    "order": 4,
    "is_active": true
  },
  {
    "code": "SEPARATED",
    "label": {
      "en": "Separated",
      "es": "Separado/a"
    },
    "order": 5,
    "is_active": true
  },
  {
    "code": "WIDOWED",
    "label": {
      "en": "Widowed",
      "es": "Viudo/a"
    },
    "order": 6,
    "is_active": true
  }
]
